<template>
  <div class="post-hover">
    <slot></slot>
    <div class="overlay"></div>
    <div class="information">
      <div class="description">
        <vue-markdown v-if="post.description">{{ post.description }}</vue-markdown>
      </div>

      <div class="counters">
        <div v-if="post.counters && post.counters.video" class="counter" title="Відео">
          <!-- <v-icon>videocam</v-icon>{{ post.counters.video }} -->
          <!-- <v-icon>play_circle_filled</v-icon><v-icon>play_arrow</v-icon> -->
          <v-icon>play_circle_outline</v-icon>{{ post.counters.video }}
        </div>
        <div v-if="post.counters && post.counters.audio" class="counter" title="Аудіо">
          <v-icon>audiotrack</v-icon>{{ post.counters.audio }}
        </div>
        <div v-if="post.counters && post.counters.image" class="counter" title="Зображення">
          <v-icon>photo</v-icon>{{ post.counters.image }}
        </div>
        <div v-if="post.counters && post.counters.comment" class="counter comments" title="Коментарі">
          <!-- <v-icon>chat_bubble</v-icon>{{ post.counters.comment }} -->
          <v-icon>question_answer</v-icon>{{ post.counters.comment }}
          <inline-badge v-if="updated && updated.comment"></inline-badge>
        </div>
      </div>
      <div class="publisher">
        <v-avatar :size="24">
          <img :src="post.author.photoUrl">
        </v-avatar>

        <v-spacer></v-spacer>

        {{ date }}
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import remark from 'remark';
import stripMd from 'strip-markdown';
import VueMarkdown from 'vue-markdown';
import InlineBadge from '@/components/InlineBabge';

export default {
  name: 'PostHover',
  components: {
    VueMarkdown,
    InlineBadge,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
    updated: true,
  },
  data() {
    return {
      description: '',
    };
  },
  computed: {
    date() {
      return moment(this.post.created).format('DD.MM.YYYY HH:mm');
    },
  },
  mounted() {
    remark()
      .use(stripMd)
      .process(this.post.description, (_, plainText) => {
        this.description = plainText && plainText.contents;
      });
  },
};

</script>

<style scoped>

.post-hover {
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  padding: 10px;
  /*border: solid 1px green;*/
  /*left: 5px;*/
  z-index: 7;
  background: #fcfcfc;
  box-shadow: 0 0 5px rgba(0,0,0, .2);
  color: #333;
  /*font-size: 70%;*/
}

.description {
  font-size: 14px;
  color: rgba(0,0,0, .3);
  max-height: 50px;
  overflow: hidden;
  /*white-space: nowrap;*/
  /*overflow: hidden;*/
  /*text-overflow: ellipsis;*/
  /*display: none;*/
}

.counters {
  /*margin: 10px 0 5px 0;*/
  margin: 20px 0 10px 0;
  /*margin: 20px 0;*/
  display: flex;
  flex-direction: row;
  /*justify-content: space-evenly;*/
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.counter {
  width: 60px;
}

.counters .icon {
  font-size: 40px;
  color: #aaa;
}

.counters .counter.comments .icon {
  font-size: 32px;
}

.publisher {
  display: flex;

  flex-direction: row;
  align-items: center;
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/PostHover.vue